import React, { useState } from "react";
import Modal from "react-modal";
import { Button } from '@material-ui/core';
import moment from 'moment';
import _ from "lodash";
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

const Modalz = (props) => {
    const { start, end, setDate, setEnd } = props;
    const [startDate, setStartDate] = useState(moment(start).startOf('month').toDate());
    const [endDate, setEndDate] = useState(moment(end).endOf('month').toDate());
    function handleClose() {
        props.setIsOpen(false);
    }

    const handleSelect = ({ selection: { startDate, endDate } }) => {
        setStartDate(moment(startDate).startOf('day').toDate());
        setEndDate(moment(endDate).endOf('day').toDate());
    }

    const handleClick = () => {
        setDate(startDate)
        setEnd(endDate != startDate ? endDate : null)
        localStorage.setItem("startDate", moment(startDate).startOf('day').toDate())
        localStorage.setItem("endDate", moment(endDate).endOf('day').toDate())
        handleClose()
    }

    return (
        <Modal
            isOpen={props.modalIsOpen}
            ariaHideApp={false}
            onRequestClose={handleClose}
            contentLabel="Modal Select Date"
            className="sssszzz"
        >
            <div style={{ display: 'flex', textAlign: 'center', justifyContent: 'center', paddingTop: '20px' }}>

                <DateRangePicker
                    className="rdr"
                    dragSelectionEnabled={false}
                    ranges={[{ startDate, endDate, key: 'selection' }]}
                    onChange={handleSelect}
                />
            </div>
            <div style={{ display: 'flex', textAlign: 'center', paddingTop: '20px', justifyContent: 'center' }}>
                <Button variant='contained'
                    style={{ backgroundColor: "#6ab23a", color: 'whitesmoke', whiteSpace: 'nowrap' }}
                    size="small"
                    onClick={() => handleClick()}>Submit</Button>
                <Button variant='contained'
                    style={{ backgroundColor: "#f27474", color: 'whitesmoke', whiteSpace: 'nowrap', marginLeft: '5px' }}
                    size="small"
                    onClick={() => handleClose()}>Close</Button>
            </div>
        </Modal>

    );
}
export default Modalz;
